function withOpacity(color, opacity) {
  const r = parseInt(color.slice(1, 3), 16),
    g = parseInt(color.slice(3, 5), 16),
    b = parseInt(color.slice(5, 7), 16)

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')'
}

const Colors = {
  // DEFAULT COLORS
  White: '#ffffff',
  Black: '#000000',
  LightGrey: '#f1f1f1',
  CoolGrey: '#889298',
  Grey: '#122632',
  DarkGrey: '#4d5c65',
  Red: '#e03c31',
  PaleRed: '#e03c31',
  Orange: '#FDA609',
  Yellow: '#eaaa00',
  LightBlue: '#4ba7e8',
  // CORPORATE BRAND COLORS
  Light: '#eefcff',
  Aqua: '#08bad2',
  Fuschia: '#e782a9',
  Violet: '#8031a7',
  Blue: '#407ec9',
  CorporateGreen: '#18ad84',
  Brand: '#076283',
  TextBrand: '#008476',
  NewGrey: '#979797',
  DarkGrey2: '#333333',
  GrassGreen: '#b0d121',
  // Gradients
  spectrum1:
    'linear-gradient(90deg, rgba(77,185,100,1) 0%, rgba(231,179,80,1) 49%, rgba(236,148,157,1) 100%)',
  spectrum2:
    'linear-gradient(90deg, rgba(226,83,101,1) 0%, rgba(236,108,72,1) 49%, rgba(209,144,172,1) 100%)',
  spectrum3:
    'linear-gradient(90deg, rgba(189,173,215,1) 0%, rgba(135,81,159,1) 49%, rgba(177,127,157,1) 100%)',
  spectrum4:
    'linear-gradient(90deg, rgba(219,148,159,1) 0%, rgba(205,176,156,1) 49%, rgba(38,176,180,1) 100%)',
  spectrum5:
    'linear-gradient(270deg, rgba(99,179,93,1) 0%, rgba(85,187,176,1) 49%, rgba(212,170,154,1) 100%)',

  gradientBackground: `linear-gradient(90deg, #EAF9FF 0%, #efefef 100%)`,
}

Colors['White012'] = withOpacity(Colors.White, 0.12)
Colors['White040'] = withOpacity(Colors.White, 0.4)
Colors['White060'] = withOpacity(Colors.White, 0.6)
Colors['White080'] = withOpacity(Colors.White, 0.8)
Colors['White095'] = withOpacity(Colors.White, 0.95)
Colors['Black080'] = withOpacity(Colors.Black, 0.8)
Colors['Black06'] = withOpacity(Colors.Black, 0.6)
Colors['Black038'] = withOpacity(Colors.Black, 0.38)
Colors['Black012'] = withOpacity(Colors.Black, 0.12)
Colors['Black005'] = withOpacity(Colors.Black, 0.05)
Colors['Brand02'] = withOpacity(Colors.Brand, 0.2)
Colors['Brand05'] = withOpacity(Colors.Brand, 0.5)
Colors['Grey0'] = withOpacity(Colors.Grey, 0)
Colors['Grey008'] = withOpacity(Colors.Grey, 0.08)
Colors['Grey024'] = withOpacity(Colors.Grey, 0.24)
Colors['Grey04'] = withOpacity(Colors.Grey, 0.4)
Colors['Grey06'] = withOpacity(Colors.Grey, 0.6)
Colors['Grey08'] = withOpacity(Colors.Grey, 0.8)
Colors['DarkGrey16'] = withOpacity(Colors.DarkGrey2, 0.16)
Colors['Aqua020'] = withOpacity(Colors.Aqua, 0.2)
Colors['Aqua060'] = withOpacity(Colors.Aqua, 0.6)
Colors['Aqua080'] = withOpacity(Colors.Aqua, 0.8)
Colors['Aqua05'] = withOpacity(Colors.Aqua, 0.5)

export default Colors

export { withOpacity }
